import { createStore, combineReducers, applyMiddleware } from "redux";
import logger from "redux-logger";
import thunk from "redux-thunk";
import { BOOKING } from "./booking";
import { BUS } from "./bus";
import { USER } from "./user";

export const configureStore = () => {
  const store = createStore(
    combineReducers({
      busesarray: BUS,
      booking: BOOKING,
      user: USER
    }),
    applyMiddleware(thunk, logger)
  );
  return store;
};
